module.exports = __webpack_public_path__ + "img/np_compare_2889489_F0CD5E.763a989e.svg";